import React from 'react'
import { ReactComponent as PitchIcon } from '../assets/icons/pitch.svg'
import styled from '@emotion/styled/macro'

const FlexRow = styled('a')`
    display: flex;
    justify-content: space-between;
    max-width: 30rem;
    padding: 0.25rem;
    border-radius: 0.5rem;
    width: fit-content;
    margin-left: 0.5rem;
    background: var(--colors-grays-20);
    transition: 0.5s ease all;
    align-items: center;
    &:hover {
        background: var(--colors-primary-accent);
    }
    small {
        margin-left: 0.5rem;
    }
`

const AddressLinkComponent = ({ address, title, ...props }) =>
    address ? (
        <FlexRow
            title={title}
            {...props}
            href={`https://google.com/maps/place?q=${encodeURI(address)}`}
            target="_blank"
            rel="noreferrer"
        >
            <PitchIcon height="1.5em" width="1.5em"></PitchIcon>
            <small>{address}</small>
        </FlexRow>
    ) : null

export default AddressLinkComponent
